<script lang="ts" setup>
import type { Advantages } from '~~/server/api/forms/form'

export interface PagesOnlineServicesAdvantagesProps {
    data: Advantages
}

const props = defineProps<PagesOnlineServicesAdvantagesProps>()
</script>
<template>
  <section class="mt-10 mt-md-15 mb-4 mb-lg-0">
    <Tracker :data="{ position: props.data.title }">
      <Box
        color="green"
        padding="p-4"
        size="small"
        class="rounded-3"
      >
        <h2 class="zeta mb-2">
          {{ props.data.title }}
        </h2>
        <ul>
          <li
            v-for="(advantage, index) in props.data.advantage"
            :key="`adv-${index}`"
            class="d-flex align-items-center"
            :class="{
              'mb-2': index < props.data.advantage.length - 1,
            }"
          >
            <IconImg
              :src="advantage.icon.path"
              :size="16"
              class="me-2 text-green-5"
            />
            <VNuxtLink
              :to="advantage.url"
              class="text-green-5 text-decoration-underline"
              :label="advantage.text"
            >
              {{ advantage.text }}
            </VNuxtLink>
          </li>
        </ul>
      </Box>
    </Tracker>
  </section>
</template>
